import { filter, fromEvent, merge, scan } from 'rxjs';

export default (element: Element, callback: (event?: Event) => void, once = true) => {
  const transitionProperty = getComputedStyle(element).getPropertyValue('transition-duration');
  const hasDuration = parseFloat(transitionProperty || '0') !== 0;

  if (!hasDuration) {
    callback();

    return;
  }

  const seed = <{ properties: string[]; event: TransitionEvent | undefined }>{
    properties: [],
    event: undefined,
  };

  const $subscription = merge(
      fromEvent<TransitionEvent>(element, 'transitionstart'),
      fromEvent<TransitionEvent>(element, 'transitionend'),
  )
      .pipe(
          filter((event) => event.target === element),
          scan((accumulated, current) => {
            const { properties } = accumulated;

            if (current.type === 'transitionstart') {
              properties.push(current.propertyName);
            }

            if (current.type === 'transitionend') {
              return {
                properties: properties.filter((propertyName) => propertyName !== current.propertyName),
                event: current,
              };
            }

            return {
              properties,
              event: current,
            };
          }, seed),
          filter(({ properties }) => properties.length === 0),
      )
      .subscribe(({ event }) => {
        callback(event);

        if (once) {
          $subscription.unsubscribe();
        }
      });
};
